import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import useQuery, { _get, _post } from "../../Utils/Helper";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import Title from "antd/es/typography/Title";
import Paragraph from "antd/es/typography/Paragraph";
function ViewAssignment() {

  // interface QResponse{
  //   id?:number,
  //   question_id: string;
  //   assignment_id: string;
  //   admission_no: string;
  //   response: string;
  //   subject:string;
  //   class_name: string;
  // }
  // const _QResponse ={
  //   question_id: "",
  //   assignment_id: "",
  //   admission_no: "",
  //   response: "",
  //   subject: "",
  //   class_name:""
  // }
  interface StudentAssignment {
    id: string;
    class_name: string;
    attachment: string;
    response: string;
    admission_no: string;
    student_name: string;
    teacher_id: string;
    teacher_name: string;
    subject: string;
    question_id: string;
  }
  const _studentAssignment = {
    id:"",
    class_name: "",
    attachment: "",
    response: "",
    admission_no: "",
    student_name: "",
    teacher_id: "",
    teacher_name: "",
    subject: "",
    question_id: "",
  };

  const { user } = useSelector((s: RootState) => s.auth)

  const onChangeFile = (info: any) => {
    const { file } = info;

    if (file.status === "done") {
      const data = file.response;
      setStudentAssignment((prev: any) => ({ ...prev, attachment: data.url }));
      toast.success("Attachment uploaded successfully!");
    } else if (file.status === "error") {
      toast.error("Error uploading attachment.");
    }
  };

  type Option = {
    value: string;
    is_correct: boolean;
  };

  type Question = {
    id: string;
    assignment_id: string;
    question_text: string;
    question_type: string;
    options: string; // Stored as JSON string in the data
    marks: string;
    correct_answer: string;
    class_name: string;
    subject: string;
    admission_no: string;
    response:string
  };

  type Assignment = {
    id: string;
    title: string;
    class_name: string;
    teacher_name: string;
    content: string;
    subject: string;
    submission_date: string;
    attachment: string;
  }
  const _assignment = {
    id:"",
    title: "",
    class_name: "",
    teacher_name: "",
    content: "",
    subject: "",
    submission_date: "",
    attachment: "",
  }
  const q = useQuery();
  const id = q.get('id');

  // const [responses, setResponses] = useState<QResponse[]>([]);
  const [studentAssignment, setStudentAssignment] = useState<StudentAssignment>(_studentAssignment);
  const [assignment, setAssignment] = useState<Assignment>(_assignment);
  // setQuestions
  const [questions, setQuestions] = useState<Question[]>([]);

  // const handleOptionChange = (index: number, questionId: string, selectedValue: string) => {
  //   // Check if a response for the question already exists
  //   const existingResponseIndex = questions[index]
  //   alert(JSON.stringify(existingResponseIndex));
    
  //   const updatedResponse = {
  //     ...existingResponseIndex,
  //     admission_no: user.id,
  //     response: selectedValue,
  //     assignment_id: studentAssignment.id,
  //     subject:assignment.subject,
  //     class_name:user.class_name,
  //   };
  
  //   // Update the response if it exists, or add a new one if it doesn't
  //   const updatedResponses = [...questions];
  //   if (existingResponseIndex?.id) {
  //     updatedResponses[index] = updatedResponse;
  //   } else {
  //     updatedResponses.push(updatedResponse);
  //   }
  
  //   // Update the state
  //   setQuestions(updatedResponses);
  // };
  
  const handleOptionChange = (index: number, questionId: string, selectedValue: string) => {
    const updatedQuestions = questions.map((question) => {
      if (question.id === questionId) {
        return {
          ...question,
          question_id: question.id,
          admission_no: user.admission_no,
          response: selectedValue,
          assignment_id: studentAssignment.id,
          subject: assignment.subject,
          class_name: user.class_name,
        };
      }
      return question;
    });
  
    setQuestions(updatedQuestions);
  };
  
  const handleSubmit = (e:React.FormEvent) => {
    e.preventDefault();
   _post(
        "assignment/responses",
        {
          ...studentAssignment, 
          student_name:user.student_name, 
          admission_no:user.admission_no,
          class_name:user.current_class,
          assignment_id:id,
          subject:assignment.subject,
          responses:questions,
          query_type: 'insert'
        },
        (resp) => {
          if(resp.success){
          setStudentAssignment(_studentAssignment);
          getStudentAssignment();
          toast.success("Assignment submitted successfully!");
          }
        },
        (err) => {
          console.error("Error submitting assignment:", err);
          toast.error("Error submitting assignment.");
        }
      );
  };

  const getStudentAssignment = useCallback(() => {
    if (user.id) {
      _get(
        `student/assignments?query_type=select&admission_no=${user.id}&assignment_id=${id}`,
        (res) => {
          if (res.success && res.data.length) {
            console.log(res);
            setStudentAssignment(res.data[0]);
          }
        },
        (err) => {
          console.error(err);
        }
      );
    }
  }, [id, user.id]);

  const getAssignment = useCallback(() => {
    if (id && user.id) {
      _get(
        `assignments?query_type=select&id=${id}`,
        (res) => {
          console.log(res);
          setAssignment(res.data[0]);
          const assig = res.data[0]
          setStudentAssignment((p) => ({ ...p, teacher_name: assig.teacher_name, teacher_id: assig.teacher_id, class_name: assig.class_name, assignment_id: assig.id, admission_no: user.id, student_name: user.full_name }))
        },
        (err) => {
          console.error(err);
        }
      );
      _get(
        `assignments?query_type=select-questions&id=${id}`,
        (res) => {
          if (res.success) {
            console.log(res);
            setQuestions(res.data);
          }
        },
        (err) => {
          console.error(err);
        }
      );
    }
  }, [id, user.id]);

  useEffect(() => {
    getAssignment();
  }, [getAssignment]);


  const getAlpha = (index: number) => {
    switch (index) {
      case 0:
        return 'A';
      case 1:
        return 'B';
      case 2:
        return 'C';
      case 3:
        return 'D';
    }
  }
  return (
    <div className="page-wrapper">
      <div className="content">

        <div className="card">
          <div className="card-header">
            <div className="card-title">

              <Title level={3} style={{ textAlign: "center" }}>
                Assignment:  {assignment.title}
              </Title>
            </div>
          </div>
          <div className="card-body">

            {assignment.id ? (
              <div style={{ marginBottom: "24px", padding: "16px", border: "1px solid #f0f0f0", borderRadius: "8px" }}>
                <Paragraph>
                  <b>Subject:</b> {assignment.subject}
                </Paragraph>
                <Paragraph>
                  <b>Teacher:</b> {assignment.teacher_name}
                </Paragraph>
                <Paragraph>
                  <b>Due Date:</b> {assignment.submission_date}
                </Paragraph>
                <Paragraph>
                  <b>Assignment:</b> {assignment.title}
                </Paragraph>
                {assignment.attachment ? <Paragraph>
                  <b>Attachment:</b>  <a href={assignment.attachment} target="_blank" rel="noopener noreferrer">
                    View Attachment
                  </a>
                </Paragraph> : null}
              </div>
            ) : null}
          </div>
        </div>
        
        <div className="card">
          <div className="card-header">
            <div className="card-title">
              <h3>Questions</h3>
            </div>
          </div>
          <div className="card-body">
            <form>
              {questions.map((question:Question, index:number) => {
                const options: Option[] = JSON.parse(question.options);

                return (

                  <div key={question.id} className="question-container">
                    <h4>
                      {question.question_text} <span>({question.marks} marks)</span>
                    </h4>

                    {/* {JSON.stringify(question)} */}
                    {question.question_type === "Multiple Choice" && (
                      <div className="row">
                        {options.map((option, index) => (
                          <div key={index} className="col-12 col-sm-6 mb-3">
                            {/* {JSON.stringify(option)} */}
                            <div className="form-check">
                              ({getAlpha(index)}). &nbsp;
                              <input
                                className="form-check-input"
                                style={{ border: '1px solid blue' }}
                                type="radio"
                                id={`q${question.id}_option${index}`}
                                name={`question_${question.id}`}
                                value={option.value}
                                checked={question.response === option.value}
                                onChange={() => handleOptionChange(index, question.id, option.value)}
                              />
                              <label className="form-check-label" htmlFor={`q${question.id}_option${index}`}>
                                {option.value}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {question.question_type === "True/False" && (
                      <div className="row">
                        {["True", "False"].map((value, index) => (
                          <div key={index} className="col-12 col-sm-6 mb-3">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                id={`q${question.id}_tf${index}`}
                                name={`question_${question.id}`}
                                value={value}
                                checked={question.response === value}

                                onChange={() => handleOptionChange(index, question.id, value)}
                              />
                              <label className="form-check-label" htmlFor={`q${question.id}_tf${index}`}>
                                {value}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {["Short Answer",'Fill in the Blank'].includes(question.question_type) && (
                      <div className="mb-3">
                        <label htmlFor={`q${question.id}_short`} className="form-label">
                          Answer:
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          id={`q${question.id}_short`}
                          value={questions[index]?.response}
                          onChange={(e) => handleOptionChange(index, question.id, e.target.value)}
                        />
                      </div>
                    )}

                    {question.question_type === "Essay" && (
                      <div className="mb-3">
                        <label htmlFor={`q${question.id}_essay`} className="form-label">
                          Answer:
                        </label>
                        <textarea
                          className="form-control"
                          id={`q${question.id}_essay`}
                          rows={5}
                          value={questions[index]?.response}
                          onChange={(e) => handleOptionChange(index, question.id, e.target.value)}
                        ></textarea>
                      </div>
                    )}

                  </div>
                );
              })}
              <hr/>
              <div className="col-md-12 text-center"><button onClick={handleSubmit} className="btn btn-success" type="submit">Submit</button></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAssignment;